import React from 'react'
import AuthHeader from './AuthHeader'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import BlueTypography from './typography/BlueTypography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

// all styles
// const styles = {
//   h1: {
//     letterSpacing: '0.25px',
//     marginBottom: '25px',
//     color: '#3A7294'
//   }
// };

const font = "'Noto Sans', sans-serif";

const theme  = createMuiTheme({
    typography: {
    fontFamily: font
  }
});

class EmailSent extends React.PureComponent {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <section className="header">

          <AuthHeader />

          <div className="inner">
            <Grid container spacing={0} justify="center">
              <Grid item xs={12} md={4}>
                <Paper className="no-boxshadow">
                  <div>
                    <BlueTypography
                      variant="display1"
                      align="center"
                      className="c-blue ls-025"
                    >
                      Email Sent!
                    </BlueTypography>

                    <div className="mt-24">
                      <BlueTypography
                        className="ls-28 ls-050"
                        variant="subheading"
                        align="center"
                      >
                        Check you inbox for instructions on how to reset your password.
                      </BlueTypography>
                    </div>


                  </div>
                </Paper>
              </Grid>
            </Grid>
          </div>

        </section>
      </MuiThemeProvider>
    )
  }
}

export default EmailSent



// WEBPACK FOOTER //
// ./src/js/components/EmailSent.js